import { ApplicationService } from '~/services/core/application.service'
import {
  Provider,
} from '~/core/offer.types'

export interface ArticleSlugMeta {
  en: string,
  de: string,
  fr: string,
}

export interface SingleProviderArticle {
  content: string,
  image_url: string,
  image_alt?: string,
  meta_description: string,
  pk: number,
  published_date: string,
  slug: string,
  slug_meta: ArticleSlugMeta,
  sort_order: number,
  title: string,
}

/* eslint-disable camelcase */

interface ComparatorBaseOffersDTO {
  count: number,
  next?: null | string,
  previous?: null | string,
  result_match_filter: boolean,
}

export interface CompareOfferDTO<T> extends ComparatorBaseOffersDTO {
  results: T,
}

// TODO: Must be moved out of the service file
export interface DatesValidationDTO {
  dates: {
    min: number,
    max: number,
    range: {
      start: string,
      end: string,
    },
    exclude: string[],
  },
}

// TODO:
//  - Remove any
export class OfferService extends ApplicationService {
  get baseUrl () {
    return this.runtimeConfig.BASE_API_URL
  }

  getProvidersList (): Promise<Provider[]> {
    return this.get(
      '/api/providers/',
      {},
      {
        cache: {
          excludeFromCache: false,
        },
      },
    )
  }

  getProviderBySlug (slug: string): Promise<Provider> {
    return this.get(
      `/api/providers/${slug}/`,
    )
  }

  getProviderContentBySlug (slug: string): Promise<any> {
    return this.get(
      '/api/providers/articles/',
      {
        provider: slug,
      },
    )
  }
}
